const locale = {
  placeholder: 'Vali aeg'
};
export default locale;